import React, { useState, useEffect } from 'react';
import { Save, Settings } from 'lucide-react';
import { Card, CardContent } from '../../../../components/ui/card';
import { Input } from '../../../../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';
import { UpdateSystemSettings } from '../../../../redux/UserManagement/saga';
import { useDispatch, useSelector } from 'react-redux';
import { Notification } from '../../../../components/ui/custom-notification';
import { getUserAccessPermissions } from '../../../../redux/UserManagement/actions';

interface GeneralSettingsProps {
  timeZone: string;
  unit: string;
  onTimeZoneChange: (value: string) => void;
  onUnitChange: (value: string) => void;
}

export const GeneralSettings: React.FC<GeneralSettingsProps> = ({
  timeZone,
  unit,
  onTimeZoneChange,
  onUnitChange
}) => {
  // Select user permissions state from Redux store
  const userPermissions = useSelector((state: any) => state.userManagement?.userPermissions.data.data);
const [systemSettings, setSystemSettings] = useState({
  companyName: userPermissions?.companyName || '',
  timeZone: userPermissions?.timeZone || 'utc',
  unit: userPermissions?.unit || 'Inches',
});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  // Update form values when userPermissions data changes
  useEffect(() => {
    if (userPermissions) {
      setSystemSettings({
        companyName: userPermissions.companyName || '',
        timeZone: userPermissions.time_zone || 'utc',
        unit: userPermissions.unit || 'Imperial',
      });
    }
  }, [userPermissions]);

  const handleSave = async () => {
    if(!userPermissions?.user_id) {
     Notification.warning('User ID is required');
      return;
    }
    setLoading(true);
    const data = {
      companyName: systemSettings.companyName,
      timeZone: timeZone,
      unit: unit,
    };
   const res = await UpdateSystemSettings(userPermissions.user_id, data);
    if (res) {
    
    }
    setLoading(false);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
      <h2 className="text-lg font-semibold flex items-center gap-2">
        <Settings className="h-5 w-5 text-[#EB1C37]" />
        General Settings
      </h2>
             <Button onClick={handleSave} className="ml-auto" disabled={loading}
             loading={loading}
             loadingText='Saving...'
             >
         <Save className="h-5 w-5" /> Save
       </Button>
      </div>
      <Card className="border border-gray-200 bg-white">
        <CardContent className="p-6 space-y-4">
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="text-sm font-medium mb-1.5 block">Company Name</label>
              <Input 
                placeholder="Enter company name" 
                className="bg-white"
                value={systemSettings.companyName}
                onChange={(e) => setSystemSettings({...systemSettings, companyName: e.target.value})}
              />
            </div>
            <div>
              <label className="text-sm font-medium mb-1.5 block">Default Time Zone</label>
              <Select value={timeZone} onValueChange={onTimeZoneChange}>
                <SelectTrigger className="bg-white">
                  <SelectValue placeholder="Select time zone" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="utc">UTC</SelectItem>
                  <SelectItem value="est">Eastern Time</SelectItem>
                  <SelectItem value="pst">Pacific Time</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="text-sm font-medium mb-1.5 block">Default Unit</label>
              <Select value={unit} onValueChange={onUnitChange}>
                <SelectTrigger className="bg-white">
                  <SelectValue placeholder="Select default unit" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Metric">Metric</SelectItem>
                  <SelectItem value="Imperial">Imperial</SelectItem>
                </SelectContent>
              </Select> 
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}; 